// extracted by mini-css-extract-plugin
module.exports = {"sectionContent":"GenresPage_sectionContent__31hKa","content":"GenresPage_content__32hUd"};